import Vue from "vue";
import Vuex from "vuex";
import puertos from "./modules/puertos";
import whatsapp from "./modules/whatsapp";
import services from "./modules/services";
import calculadora from "./modules/calculadora";
import departamento from "./modules/departamento";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    puertos,
    whatsapp,
    services,
    calculadora,
    departamento,
  },
});
